module.exports = __webpack_public_path__ + "img/21.c058ad3f.jpg";